import { useContext } from 'react';
import { EligibilityStatus } from 'services/intelligentShoppingExperience/types';
import ShopByListContext from './ShopByListContext';

const useShopByList = () => {
  const shopByListContext = useContext(ShopByListContext);

  if (shopByListContext === null) {
    throw new Error('useShopByList must be used within a ShopByListProvider');
  }

  return shopByListContext === EligibilityStatus.ELIGIBLE;
};

export default useShopByList;
